module.exports = __webpack_public_path__ + "img/icon-speed-5.c570ab86.svg";